export default "__VITE_ASSET__Cr4ys$2V__"